const getters = {
  session: state => state['Function/Auth']['session'],
  HotKeyword: state => state['app']['HotKeyword'],
  BannerNavPreset: state => state['app']['BannerNavPreset'],
  BannerSwiperPreset: state => state['app']['BannerSwiperPreset'],
  BestSalerPreset: state => state['app']['BestSalerPreset'],
  Team_ProductType: state => state['Function/Product/Line/Team']['ProductType'],
  Team_TeamType: state => state['Function/Product/Line/Team']['TeamType'],
  Team_PriceType: state => state['Function/Product/Line/Team']['PriceType'],
  SysUserRole: state => state['Function/SysUser/Role']['list'],
};
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js